/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OperationTypeEnum,
    OperationTypeEnumFromJSON,
    OperationTypeEnumFromJSONTyped,
    OperationTypeEnumToJSON,
} from './OperationTypeEnum';
import {
    PersonalAssetHistoryMetaDataDto,
    PersonalAssetHistoryMetaDataDtoFromJSON,
    PersonalAssetHistoryMetaDataDtoFromJSONTyped,
    PersonalAssetHistoryMetaDataDtoToJSON,
} from './PersonalAssetHistoryMetaDataDto';

/**
 * 
 * @export
 * @interface PersonalAssetHistoryDto
 */
export interface PersonalAssetHistoryDto {
    /**
     * 
     * @type {PersonalAssetHistoryMetaDataDto}
     * @memberof PersonalAssetHistoryDto
     */
    metaData?: PersonalAssetHistoryMetaDataDto;
    /**
     * 
     * @type {OperationTypeEnum}
     * @memberof PersonalAssetHistoryDto
     */
    operationType: OperationTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetHistoryDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetHistoryDto
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetHistoryDto
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetHistoryDto
     */
    personalAssetId: string;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetHistoryDto
     */
    date: Date;
}

export function PersonalAssetHistoryDtoFromJSON(json: any): PersonalAssetHistoryDto {
    return PersonalAssetHistoryDtoFromJSONTyped(json, false);
}

export function PersonalAssetHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetHistoryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metaData': !exists(json, 'metaData') ? undefined : PersonalAssetHistoryMetaDataDtoFromJSON(json['metaData']),
        'operationType': OperationTypeEnumFromJSON(json['operationType']),
        'id': json['id'],
        'value': json['value'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'personalAssetId': json['personalAssetId'],
        'date': (new Date(json['date'])),
    };
}

export function PersonalAssetHistoryDtoToJSON(value?: PersonalAssetHistoryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metaData': PersonalAssetHistoryMetaDataDtoToJSON(value.metaData),
        'operationType': OperationTypeEnumToJSON(value.operationType),
        'id': value.id,
        'value': value.value,
        'note': value.note,
        'personalAssetId': value.personalAssetId,
        'date': (value.date.toISOString()),
    };
}

